import types from './types';
import {
  getUser,
  login as _login,
  logout as _logout,
  validateApplicationRole as _validateApplicationRole,
} from '@/core/auth';
import { clearCache, getUserMenu, getAdditionalProfileInfo } from '../api';

export default {
  async init({ state, commit, dispatch }) {
    try {
      const user = await getUser();
      commit(types.SET_USER, user);

      if (state.userHasValidRole === null) {
        const hasValidRole = await _validateApplicationRole();

        if (!hasValidRole) {
          await dispatch('logout');
          return;
        }

        commit(types.SET_USER_HAS_VALID_ROLE, hasValidRole);
        sessionStorage.setItem(
          'user-has-valid-role',
          JSON.stringify(hasValidRole)
        );
      }

      if (
        state.user &&
        (!state.userMenu || !state.companies || !state.permissions)
      ) {
        const [userMenu, additionalProfileInfo] = await Promise.all([
          await getUserMenu(),
          await getAdditionalProfileInfo(),
        ]);

        if (userMenu && userMenu.length) {
          commit(types.SET_MENU, userMenu);
          sessionStorage.setItem('user-menu', JSON.stringify(userMenu));
        }

        if (additionalProfileInfo) {
          const { companies, permissions, userProfile } = additionalProfileInfo;

          sessionStorage.setItem(
            'agreement-completed',
            userProfile.completeUserAgreement
          );
          sessionStorage.setItem(
            'profile-update-flag',
            !userProfile.isProfileUpdated
          );
          commit(types.SET_COMPANIES, companies);
          sessionStorage.setItem('user-companies', JSON.stringify(companies));

          commit(types.SET_PERMISSIONS, permissions);
          sessionStorage.setItem(
            'user-permissions',
            JSON.stringify(permissions)
          );
        }
      }
    } catch (ex) {
      console.log(ex);
      dispatch('clearSession');
    }
  },
  async clearSession({ commit }) {
    commit(types.SET_USER, null);
    commit(types.SET_MENU, null);
    commit(types.SET_PERMISSIONS, null);
    commit(types.SET_COMPANIES, null);
    commit(types.SET_USER_HAS_VALID_ROLE, null);
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('user-menu');
    sessionStorage.removeItem('user-permissions');
    sessionStorage.removeItem('user-companies');
    sessionStorage.removeItem('user-is-Logging-out');
    sessionStorage.clear();
    await clearCache();
  },
  login() {
    _login();
  },

  logout({ state, dispatch }) {
    let logoutId = state.user.profile.sub;
    _logout();
    dispatch('clearSession').then(function() {
      /* Señor FORCE */
      let urlLogout = process.env.VUE_APP_URL_AUTH;
      urlLogout += process.env.VUE_APP_ACR_URL_LOGOUT;
      urlLogout += '/?logoutid=' + logoutId;
      urlLogout +=
        '&redirectUrl=' + process.env.VUE_APP_URL_AUTH_POST_LOGOUT_REDIRECT_URI;
      window.location.replace(urlLogout);
    });
  },
  setMenuItemId(context, menuItemId) {
    context.commit(types.SET_MENU_ITEM_ID, menuItemId);
  },

  setMenu(context, menus) {
    context.commit(types.SET_MENU, menus);
    sessionStorage.setItem('user-menu', JSON.stringify(menus));
  },
};
